import BaseResource from './BaseResource'

export default class EnumerationValues extends BaseResource {
  static endpoint = '/api/v1/enumerationvalues' // /profile
}
